import { Card, CardContent } from 'shared/ui/card'
import type { ClosePermitStats as ClosePermitStatsType } from './types'

interface ClosePermitStatsProps {
  statistics: ClosePermitStatsType
}

export function ClosePermitStats({ statistics }: ClosePermitStatsProps) {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-5">
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-4">
          <p className="text-sm text-slate-500">Open</p>
          <p className="mt-2 text-3xl font-semibold text-blue-600">{statistics.opened}</p>
        </CardContent>
      </Card>
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-4">
          <p className="text-sm text-slate-500">Close</p>
          <p className="mt-2 text-3xl font-semibold text-emerald-600">{statistics.closed}</p>
        </CardContent>
      </Card>
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-4">
          <p className="text-sm text-slate-500">Cold Work</p>
          <p className="mt-2 text-3xl font-semibold text-blue-600">{statistics.coldWork}</p>
        </CardContent>
      </Card>
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-4">
          <p className="text-sm text-slate-500">Hot Work</p>
          <p className="mt-2 text-3xl font-semibold text-red-600">{statistics.hotWork}</p>
        </CardContent>
      </Card>
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-4">
          <p className="text-sm text-slate-500">Confine Work</p>
          <p className="mt-2 text-3xl font-semibold text-orange-500">{statistics.confineWork}</p>
        </CardContent>
      </Card>
    </div>
  )
}
